import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Labels from './Labels';

export default function SliderBipolar({ rows, labels, minAnswerWidth }) {
  return (
    <div className="answers">
      {rows.map((row, index) => (
        <Fragment>
          <div
            id={row.id}
            className="answer--bipolar bipolar-slider"
            data-row-order={index}
          >
            <div className="bipolar-slider-row-labels">
              <span
                className="bipolar-slider-row-label bipolar-slider-row-label--left"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: row.rowLabels.beforeLabel || '&nbsp;',
                }}
              />
              <span
                className="bipolar-slider-row-label bipolar-slider-row-label--right"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: row.rowLabels.afterLabel || '&nbsp;',
                }}
              />
            </div>
            <input
              className="bipolar-slider-input"
              data-answer-id={row.id}
              value={row.initValue}
              min={row.min}
              max={row.max}
              step="1"
              readOnly
            />
            <Labels labels={labels} minAnswerWidth={minAnswerWidth} />
          </div>
          <div className="divider margin-md"></div>
        </Fragment>
      ))}
    </div>
  );
}

SliderBipolar.propTypes = {
  rows: PropTypes.array,
  labels: PropTypes.array,
  minAnswerWidth: PropTypes.number,
};
